/** @format */

import {
  BgBox,
  Content,
  ForecastAverageText,
  ForecastBox,
  ForecastColumnLeft,
  ForecastColumnRight,
  OpacitySubText,
  LabelBox,
  RegularText,
  Root,
  RowBox,
  SubText,
  ValueBox,
  DeltaBox,
  ExtraRowsBox,
} from './styles';
import {ForecastValues, TooltipRow} from '../../../../model/tooltip';
import {ChartType} from '../../../../model/common';
import getTooltipValue from '../../helpers/getTooltipValue';
import {FORECAST_KEYS} from '../../../../const';
import {getPeriodText} from '../../helpers/getPeriodText';

interface Props<ChartId> {
  bgColor: string;
  labelType?: string;
  data: TooltipRow<ChartId>;
  chartType: ChartType;
  isCompact?: boolean;
  periodDays?: string;
}

const Bubble = <ChartId,>({
  bgColor,
  chartType,
  data,
  labelType,
  periodDays,
  isCompact,
}: Props<ChartId>) => {
  const {label, value, extraRows, delta} = data;

  const innerValue = getTooltipValue(value, chartType);

  const periodLabel = getPeriodText(periodDays);

  // Очищаем от лишних записей (фикс старой реализации)
  const forecast: ForecastValues = {};
  const filteredExtraRows = extraRows?.filter(row => {
    if (row.label === FORECAST_KEYS.Average) {
      forecast.average = row.value[chartType];
      return false;
    }
    if (row.label === FORECAST_KEYS.Min) {
      forecast.min = row.value[chartType];
      return false;
    }
    if (row.label === FORECAST_KEYS.Max) {
      forecast.max = row.value[chartType];
      return false;
    }
    return true;
  });

  const isForecast = Object.keys(forecast).length > 0;

  const diff = delta?.diff[chartType];
  const percent = delta?.percent[chartType];
  const showDelta = Boolean(diff || percent);

  return (
    <Root>
      <Content isCompact={isCompact}>
        <RowBox>
          <LabelBox>
            <RegularText>{label}</RegularText>
            {labelType ? <SubText>{labelType}</SubText> : null}
          </LabelBox>

          <ValueBox>
            {innerValue ? (
              <LabelBox>
                <RegularText>{innerValue}</RegularText>
                {showDelta && (
                  <DeltaBox>
                    {periodLabel ? <OpacitySubText>{periodLabel}</OpacitySubText> : null}
                    {diff ? <SubText customColor={delta?.diffColor}>{diff}</SubText> : null}
                    {percent ? <OpacitySubText>{percent}</OpacitySubText> : null}
                  </DeltaBox>
                )}
              </LabelBox>
            ) : null}

            {isForecast && (
              <ForecastBox>
                <ForecastColumnLeft>
                  <OpacitySubText>мин</OpacitySubText>
                  <ForecastAverageText>Прогноз</ForecastAverageText>
                  <OpacitySubText>макс</OpacitySubText>
                </ForecastColumnLeft>
                <ForecastColumnRight>
                  <OpacitySubText>{forecast.min}</OpacitySubText>
                  <ForecastAverageText>{forecast.average}</ForecastAverageText>
                  <OpacitySubText>{forecast.max}</OpacitySubText>
                </ForecastColumnRight>
              </ForecastBox>
            )}
          </ValueBox>
        </RowBox>

        {filteredExtraRows?.length ? (
          <ExtraRowsBox>
            {filteredExtraRows.map(row => (
              <RowBox key={row.label}>
                <LabelBox>
                  <SubText>{row.label}</SubText>
                </LabelBox>
                <ValueBox>
                  <SubText>{getTooltipValue(row.value, chartType)}</SubText>
                </ValueBox>
              </RowBox>
            ))}
          </ExtraRowsBox>
        ) : null}
      </Content>

      <BgBox bgColor={bgColor} />
    </Root>
  );
};

export {Bubble};
